export const dccType = {
    projectCurrency: 2,
    systemSuggestion: 4,
};